import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <div className="flex items-center gap-3 mb-6">
    <span className="h-px w-10 bg-[#FF5500]" />
    <span className="font-tech text-xs uppercase tracking-[0.3em] text-[#FF5500]">
      {children}
    </span>
  </div>
);
